import { NextSearchParams } from '@/types/Next';

/**
 * The referral code a landing-page link carries (`/apply?referral=TREEHOUSE`),
 * normalised the way `ReferralCodeField` commits a typed one. Undefined when the
 * link has none, so callers can fall back to whatever the session already has.
 */
export function linkReferralCode(
  searchParams?: NextSearchParams
): string | undefined {
  const raw = searchParams?.referral;
  const value = Array.isArray(raw) ? raw[0] : raw;
  const code = value?.trim().toUpperCase();
  return code || undefined;
}
